import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8, default as _styled9, default as _styled10 } from "styled-components";
import React from 'react';
import PropTypes from 'prop-types';
import A from '@adsk/alloy-react-a';
import { OpenIcon } from '@adsk/alloy-react-icon';
import { useLocale } from '@adsk/alloy-react-locale';
import { SimpleModal } from '@adsk/alloy-react-modal';
import ACCImage from './assets/ACC_in-product.jpg';
import ACCLifecycle from './assets/Construction-Lifecycle.png';
import { HELP_LINK, LEARNING_CENTER_URL_1, LEARNING_CENTER_URL_2 } from './helpers/const';
import { bodyStyle, contentSectionStyle, contentTitleStyle, footerHelpLinkStyle, footerHelpLinkTextStyle, footerSectionStyle, imageStyle, imageTextIntroductionStyle, imageTextDescriptionStyle, imageTextLinkStyle, learningCenterStyle } from './helpers/styles';
import { subscriptionPropType } from '../../helpers/types';
import TrialModalCarousel from '../TrialModalCarousel';
import TrialModalItem from '../TrialModalItem';
const TrialModal = _ref => {
  var _T$translate;
  let {
    onClose,
    show,
    userTrials
  } = _ref;
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require(`../../i18n/${locale}.json`);
  });
  const getBannerContent = () => [/*#__PURE__*/React.createElement(_StyledDiv, {
    key: "content-1"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_StyledDiv2, null, T.translate('MODAL_IMAGE_TEXT_INTRODUCTION_1')), /*#__PURE__*/React.createElement(_StyledDiv3, null, T.translate('MODAL_IMAGE_TEXT_DESCRIPTION_1')), /*#__PURE__*/React.createElement(A, {
    style: imageTextLinkStyle,
    href: LEARNING_CENTER_URL_1,
    target: "_blank"
  }, T.translate('MODAL_IMAGE_TEXT_LINK'))), /*#__PURE__*/React.createElement("img", {
    style: imageStyle,
    src: ACCLifecycle
  })), /*#__PURE__*/React.createElement(_StyledDiv4, {
    key: "content-0"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_StyledDiv5, null, T.translate('MODAL_IMAGE_TEXT_INTRODUCTION_2')), /*#__PURE__*/React.createElement(_StyledDiv6, null, T.translate('MODAL_IMAGE_TEXT_DESCRIPTION_2')), /*#__PURE__*/React.createElement(A, {
    style: imageTextLinkStyle,
    href: LEARNING_CENTER_URL_2,
    target: "_blank"
  }, T.translate('MODAL_IMAGE_TEXT_LINK'))), /*#__PURE__*/React.createElement("img", {
    style: imageStyle,
    src: ACCImage
  }))];
  return /*#__PURE__*/React.createElement(SimpleModal, {
    title: (_T$translate = T.translate('MODAL_TITLE')) === null || _T$translate === void 0 ? void 0 : _T$translate.toString(),
    onClose: () => {
      onClose();
    },
    show: show,
    modalBodyProps: {
      style: bodyStyle
    }
  }, /*#__PURE__*/React.createElement(TrialModalCarousel, null, getBannerContent()), /*#__PURE__*/React.createElement(_StyledDiv7, null, /*#__PURE__*/React.createElement(_StyledDiv8, null, T.translate('MODAL_CONTENT_TITLE')), userTrials.map(userTrial => /*#__PURE__*/React.createElement(TrialModalItem, {
    key: userTrial.offeringCategory,
    userTrial: userTrial
  }))), /*#__PURE__*/React.createElement(_StyledDiv9, null, /*#__PURE__*/React.createElement(A, {
    style: footerHelpLinkStyle,
    href: HELP_LINK,
    target: "_blank"
  }, /*#__PURE__*/React.createElement(_StyledDiv10, null, T.translate('MODAL_FOOTER_HELP_LINK')), /*#__PURE__*/React.createElement(OpenIcon, null))));
};
TrialModal.displayName = 'TrialModal';
TrialModal.propTypes = {
  /** Handler for close modal event */
  onClose: PropTypes.func.isRequired,
  /**  Flag to display modal */
  show: PropTypes.bool.isRequired,
  /** User Trials data to display */
  userTrials: PropTypes.arrayOf(subscriptionPropType.isRequired).isRequired
};
export default TrialModal;
var _StyledDiv = _styled("div")`${learningCenterStyle}`;
var _StyledDiv2 = _styled2("div")`${imageTextIntroductionStyle}`;
var _StyledDiv3 = _styled3("div")`${imageTextDescriptionStyle}`;
var _StyledDiv4 = _styled4("div")`${learningCenterStyle}`;
var _StyledDiv5 = _styled5("div")`${imageTextIntroductionStyle}`;
var _StyledDiv6 = _styled6("div")`${imageTextDescriptionStyle}`;
var _StyledDiv7 = _styled7("div")`${contentSectionStyle}`;
var _StyledDiv8 = _styled8("div")`${contentTitleStyle}`;
var _StyledDiv9 = _styled9("div")`${footerSectionStyle}`;
var _StyledDiv10 = _styled10("div").withConfig({
  displayName: "component___StyledDiv10",
  componentId: "sc-1qhhhy1-0"
})(["", ""], footerHelpLinkTextStyle);
//# sourceMappingURL=component.js.map